import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import { WrappedFieldProps } from 'redux-form';
import i18n from '../../../i18n';

export interface NumberControlProps {
    label: string;
    // Optional:
    name?: string;
    value?: string;
    onChange?: any;
    error?: string;
    fullWidth?: boolean;
    isDisabled?: boolean;
    min?: number;
    max?: number;
    step?: number;
}

export const NumberControl: FC<NumberControlProps> = props => {
    const { error, min, max, step, ...rest } = props;
    return (
        <TextField
            InputProps={{
                disableUnderline: true,
                inputProps: {
                    min,
                    max,
                    step,
                },
            }}
            type="number"
            variant="filled"
            error={!!error}
            helperText={error}
            fullWidth={true}
            size="small"
            {...rest}
        />
    );
};

export interface NumberControlFieldOwnProps {
    label: string;
    // Optional:
    min?: number;
    max?: number;
    step?: number;
}

export type NumberControlFieldProps = NumberControlFieldOwnProps & WrappedFieldProps;

export const NumberControlField = (props: NumberControlFieldProps) => {
    const { t } = i18n.useTranslation();
    const {
        input,
        label,
        min,
        max,
        step,
        meta: { touched, invalid, error },
    } = props;
    return (
        <NumberControl
            label={label}
            min={min}
            max={max}
            step={step}
            error={touched && invalid ? t(error) : undefined}
            {...input}
        />
    );
};
